import { useState, useEffect } from 'react';
import { Card, Space } from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import PersonDrawer from '../../Common/PersonDrawer';
import utils from '../../Common/utils';
import { Pagination, Table, Button } from 'antd';
import { PlusOutlined, EditFilled } from '@ant-design/icons';
import { setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import { useSelector, useDispatch } from "react-redux";

const api = new APIClient();


const PersonsList = (props) => {
  document.title = "Osebe" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [personsData, setPersonsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const searchPending = useSelector((state) => state.Filterdata.searchPending)

  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Only the normal search box.
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      disabled: []
    }))
  }, []);

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }

  const loadPersons = () => {
    setLoading(true);
    api.get('/api/persons/', filterdata)
      .then((resp) => setPersonsData(resp))
      .finally(() => setLoading(false));
  }

  const columns = [
    {title: 'Ime in priimek', dataIndex: 'title'},
    {title: 'Uredi', key: 'edit', render: r => <Button size='small' onClick={ev => onEdit(r.id)}><EditFilled/></Button>}
  ]

  useEffect(() => {
      loadPersons()
  }, [filterdata]);


  return (
    <>
      <PersonDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedId(null);
        }}
        onDone={() => {
          loadPersons(filterdata);
          setEditedId(null);
          setOpen(false);
        }}
        id={editedId}
      />

      <Breadcrumb parentTitle="Statični podatki" pageTitle="Osebe" />

      <Card
        title='Osebe'
        extra={
          <Space>
            <Button
              onClick={ev => {
                setEditedId(null)
                setOpen(true)
              }}
              icon={<PlusOutlined />}
            />
          </Space>
        }
      >
        <Table
            size="small"
            loading={loading || searchPending}
            columns={columns}
            dataSource={personsData?.results || []}
            pagination={false}
            rowKey={obj => obj.id}
            rowClassName={(record) => {}}
        />
        <Pagination
            current={filterdata.page}
            onChange={pInx => dispatch(updateFilterData({page: pInx}))}
            showSizeChanger={false}
            {...utils.processPagination(personsData?.pagination)}
        />
      </Card>
    </>
  )
}

export default PersonsList;
